import { Link } from '@tanstack/react-router'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="mt-12 bg-gray-900 text-gray-300">
      <div className="max-w-5xl mx-auto px-4 py-8 flex flex-col items-center gap-4 text-sm md:flex-row md:justify-between">
        <Link
          to="/"
          className="font-['Montserrat',sans-serif] font-semibold text-white hover:text-gray-200 transition-colors"
        >
          HTML Editor
        </Link>
        <nav aria-label="Footer">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <li>
              <Link
                to="/about"
                className="hover:text-white transition-colors"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                className="hover:text-white transition-colors"
              >
                Terms
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                className="hover:text-white transition-colors"
              >
                Privacy
              </Link>
            </li>
            <li>
              <a
                href="mailto:support@htmleditor.io"
                className="hover:text-white transition-colors"
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
        <div className="text-gray-400 text-center md:text-right">
          © {year} Digital Rocket Factory Oy
        </div>
      </div>
    </footer>
  )
}
